<template>
    <div class="order-list" :class="{mt_80: props.margin}">
        <div class="order-list__title-box">
            <h2 class="order-list__title">Созданные заказы</h2>
            <div class="order-list__sort-box" v-if="props.sorting">
                <div class="order-list__sort" v-if="!upOrders">
                    <icon-component class="order-list__icon" name="sortUp" width="20" height="20"/>
                    <button class="order-list__sort-button" @click.prevent="sortingOrders">по возрастанию</button>
                </div>
                <div class="order-list__sort" v-else>
                    <icon-component class="order-list__icon" name="sortDown" width="20" height="20"/>
                    <button class="order-list__sort-button" @click.prevent="sortingOrders">по убыванию</button>
                </div>
            </div>
        </div>
        <ul class="order-list__list">
            <li class="order-list__item" v-for="(order, index) in quantityOrders" :key="index">
                <div class="order-list__content">
                    <span class="order-list__text order-list__index">№{{ index + 1 }}</span>
                    <span class="order-list__text order-list__name">{{ order.information.client }}</span>
                    <span class="order-list__text order-list__text_gray order-list__type">{{order.type}}</span>
                </div>
                <div class="order-list__action-box">
                    <VDropdown>
                        <button class="order-list__action">
                            <icon-component class="order-list__icon" name="action" width="32" height="32"/>
                        </button>
                        <template #popper>
                          <div class="order-list__option-box">
                            <!-- <router-link :to="`/order/${order._id}`" class="order-list__option">Подробнее</router-link> -->
                            <button class="order-list__option" @click="createOrder(order)">Отправить заказ</button>
                            <!-- <button class="order-list__option" v-if="role !== UserRole.USER" @click="deleteOrder(order._id)">Удалить заказ</button> -->
                          </div>
                        </template>
                    </VDropdown>
                </div>
            </li>
        </ul>
    </div>
</template>
<script setup lang="ts">
import iconComponent from './iconComponent.vue';
import axios from '../app/lib/api'
import { onMounted, ref, watch } from 'vue';
import {useLoadingStore, useOdrderLocalStore} from '../app/store/store';
import { ICreateOrderLocal } from '../app/lib/shemas/createOrderShema';
import toast from '../app/lib/hooks/errorToast';
import { cloneDeep } from 'lodash';

const props = defineProps({
    margin: {
        type: Boolean
    },
    sorting: {
        type: Boolean
    },
    quantity: {
        type: Number
    }
})
const loading = useLoadingStore()
const orderLocal = useOdrderLocalStore()
const orders = ref([] as unknown as ICreateOrderLocal[])
const sortOrders = ref([] as unknown as ICreateOrderLocal[])
const filteredOrders = ref([] as unknown as ICreateOrderLocal[])
const upOrders = ref(false)
const quantityOrders = ref([] as unknown as ICreateOrderLocal[])

function setQuantityOrders() {
    if (props.quantity) {
        quantityOrders.value = filteredOrders.value.slice(0, props.quantity)
    } else {
        quantityOrders.value = filteredOrders.value
    }
}

let formData = new FormData()

async function createOrder({localID, ...order}: ICreateOrderLocal) {
    try {
        loading.loading()
        const rawValue = cloneDeep(order)
        formData.append('data', JSON.stringify(rawValue))
        await axios.order.createOrder(formData)
        orderLocal.deleteOrder(localID)
        orderLocal.getOrders()
        orders.value = orderLocal.orders
        sortOrders.value = orders.value
        filteredOrders.value = sortOrders.value
        setQuantityOrders()
        loading.load()
        return toast('success', 'заказ успешно создан')
    } catch (error) {
        loading.load()
        toast('error', 'невозможно создать заказ')
    }

}

const sortingOrders = () => {
    upOrders.value = !upOrders.value
    if(upOrders) {
        sortOrders.value.reverse()
    } else {
        sortOrders.value = orders.value
    }
}

onMounted(() => {
    loading.loading()
    orderLocal.getOrders()
    orders.value = orderLocal.orders
    sortOrders.value = orders.value
    filteredOrders.value = sortOrders.value
    setQuantityOrders()
    loading.load()
})
</script>